export default "__VITE_PUBLIC_ASSET__b924d178__"